export default __webpack_public_path__ + "static/media/1891.96eee93c.png";